import { createAsyncThunk } from "@reduxjs/toolkit";
import { AccountApi, Configuration } from "api";
import { AxiosError } from "axios";
import { getBasePath } from "common/getConfiguration";
import { createErrorObject } from "errors/createErrorObject";
import { openSnackbar } from "features/ui";
import { isError } from "lodash";
import { getTranslationID } from "translation";

export const verifyAsync = createAsyncThunk<
  {
    /* Empty Object */
  },
  { code: string; email: string },
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("verifyUser/verifyAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();
  const config = new Configuration({ basePath });
  const { code, email } = args;

  try {
    // ダウンロード一覧取得するAPI呼び出し
    const accountApi = new AccountApi(config);
    const { data } = await accountApi.verifyUser({
      code,
      email,
    });

    return data;
  } catch (e) {
    if (isAxiosError(e)) {
      // TODO ステータスコードが409はメールアドレスが重複した場合
      if (e.response?.status === 409) {
        thunkApi.dispatch(
          openSnackbar({
            level: "info",
            message: getTranslationID("verifyUser.message.emailConflict"),
          })
        );
        return thunkApi.rejectWithValue({});
      }
      if (e.response?.status === 400) {
        const error = createErrorObject(e);
        if (error.errorCode === "E000205") {
          thunkApi.dispatch(
            openSnackbar({
              level: "error",
              message: getTranslationID(
                "verifyUser.message.tooManyFailedError"
              ),
            })
          );
          return thunkApi.rejectWithValue({});
        };
        if (error.errorCode === "E000601") {
          thunkApi.dispatch(
            openSnackbar({
              level: "info",
              message: getTranslationID(
                "verifyUser.message.emailError"
              ),
            })
          );
          return thunkApi.rejectWithValue({});
        };

        thunkApi.dispatch(
          openSnackbar({
            level: "error",
            message: getTranslationID("verifyUser.message.verifyCodeError"),
          })
        );
        return thunkApi.rejectWithValue({});
      }
    }
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({});
  }
});

const isAxiosError = (arg: unknown): arg is AxiosError => {
  if (!isError(arg)) {
    return false;
  }
  const errorValue = arg as AxiosError;
  return errorValue.isAxiosError;
};
